import { BoxFormStyled } from '@Usician/styles/Form.styled';
import { Heading1Styled } from '@Usician/styles/Text.styled';

import React from 'react';

import Link from 'next/link';

import { withAuth } from '@Usician/withGraph';
import { withClient } from '@Usician/withGraph';

function Home({ settings }: ForgotAccountPageProps) {
  return (
    <BoxFormStyled css={{ paddingBottom: '4rem' }}>
      <Heading1Styled>Forgot Account</Heading1Styled>
      <p>
        Please contact {settings.information.organization.name} for login info.
      </p>
      <Link passHref href="/">
        <a css={{ display: 'inline-block', marginTop: '2rem' }}>
          Back to Login &raquo;
        </a>
      </Link>
    </BoxFormStyled>
  );
}

export type ForgotAccountPageProps = ServerSidePagePropsWithClient<
  typeof getServerSideProps
>;
export const getServerSideProps = withAuth(async () => {
  return {
    props: { layout: 'PUBLIC' },
  };
}, 'PUBLIC');
export default withClient(Home);
